import React from 'react'

import { Text, Title } from '../presentation/Text'
import { useStepsActions, useStepsState } from '@btime/react-contexts'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'
import Tag from '../presentation/Tag'
import { COLORS } from '@btime/constants'

const StepItem = ({ t, title, onSelect, active, index, completed, disabled }) => {
  let color = completed ? COLORS.dark1 : COLORS.dark4
  if (disabled) color = COLORS.dark5
  if (active) color = COLORS.purple
  const number = completed && !active ? <Icon name="BsCheck" color={COLORS.white} /> : index + 1

  return (
    <Link block onClick={!disabled && onSelect}>
      <FlexGrid justify="flex-start" gutter={0.5}>
        <Tag label={number} transparent={!completed || !!active} color={color} fixedSize medium circle weight="800" />
        <Text color={color} bold={active}>
          {t(title)}
        </Text>
      </FlexGrid>
    </Link>
  )
}

const StepsSideBar = ({ t }) => {
  const { steps, activeIndex, completedIndex } = useStepsState()
  const { validateAndMoveToIndex } = useStepsActions()

  return (
    <FlexGrid justify="flex-start" align="flex-start" direction="column" gutter={0.5}>
      <Title size="h5" color={COLORS.dark3}>
        Etapas:
      </Title>

      {steps.map((step, index) => (
        <FlexCol key={index}>
          <StepItem
            index={index}
            completed={index <= completedIndex}
            disabled={index > completedIndex + 1}
            active={index === activeIndex}
            onSelect={() => validateAndMoveToIndex(index)}
            t={t}
            {...step}
          />
        </FlexCol>
      ))}
    </FlexGrid>
  )
}

export default StepsSideBar
